import React, { useEffect, useState } from 'react';
import {
  Avatar, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermission } from 'src/utils/permission';
import { fetchRiskfactorMaster, setDataSuccess, SelectVehicleMake, fetchVehicleModel } from 'src/features/staticDataSlice';
import VehiclemakeModal from 'src/pages/VehichleMake/VehicleMakeModel';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function VehicleMake({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  apiUrl,
  handleChange,
  setVehicleModelData = (data) => { }
}) {
  const dispatch = useDispatch();
  const riskFactorData = useSelector(SelectVehicleMake);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [riskFactorCreatePermission, setRiskFactorCreatePermission] = useState(false);
  const [newValue, setNewValue] = useState<string>('');

  useEffect(() => {
    checkPermission(apiUrl.permission_key, 'Create').then(setRiskFactorCreatePermission);
  }, []);

  useEffect(() => {
    if (newValue !== undefined && newValue !== '') {
      handleChange('vehicleMake', index, newValue);
      saveRow(index);
    } else if (newValue === undefined) {
      handleChange('vehicleMake', index, '');
    }
  }, [newValue]);

  const handleClose = () => {
    setOpenCreateModal(false);
    fetchRiskfactorMaster(productId, apiUrl.get_url, apiUrl.riskFactor)
      .then(data => dispatch(setDataSuccess({ dataType: apiUrl.formKey, data })));
  };

  const fetchVehicleModelDataByMake = (makeName = null) => {
    const selectedMakeName = makeName ? makeName : tableListDatas[index][apiUrl.formKey];
    const makeInfo = riskFactorData.find(make => make.name === selectedMakeName);
    if (makeInfo?.id) {
      fetchVehicleModel(makeInfo.id, 'vehichle/listVehicleModel')
        .then(data => {
          setVehicleModelData(prev => {
            // if nothing has changed, return previous state
            if (JSON.stringify(prev[index]) === JSON.stringify(data)) {
              return prev;
            }

            const updated = [...prev];
            updated[index] = data;
            return updated;
          });
        });
    }
  };

  useEffect(() => {
    if (tableListDatas[index])
      fetchVehicleModelDataByMake();
  }, [riskFactorData, tableListDatas, index, apiUrl.formKey, dispatch]);


  return (
    <>

      <FormControl fullWidth size="small">
        <StyledInputLabel id={`select-label-${apiUrl.formKey}`}>
          {label}
        </StyledInputLabel>
        <Select
          labelId={`select-label-${apiUrl.formKey}`}
          id={`select-${apiUrl.formKey}`}
          value={tableListDatas[index]?.[apiUrl.formKey] || ''}
          onChange={(e) => {
            const value = e.target.value;
            handleChange('vehicleMake', index, value);
            // handleChange('vehicleModel', index, '');
            // handleChange('vehicleVariant', index, '');

            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
            fetchVehicleModelDataByMake(value);
          }}
          style={{ width: '100%', minWidth: 180 }}
        >
          {riskFactorData?.map(riskFactor => (
            <MenuItem key={riskFactor.name} value={riskFactor.name}>
              {riskFactor.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              riskFactorCreatePermission ? '' : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar src={lock} sx={{ width: 24, height: 24, mr: 1 }} />
                  You don't have permission to add Vehicle Make
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => riskFactorCreatePermission && setOpenCreateModal(true)}
              sx={{ color: riskFactorCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
      </FormControl>

      {openCreateModal && (
        <VehiclemakeModal
          handleClose={handleClose}
          riskFactorname=""
          apiUrl={apiUrl}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default VehicleMake;
